Accounts = require 'common/lib/accounts'
Auth = require 'db/auth'
ClientConfig = require 'debug/client-config'
Controller = require 'controller'
ldclient = require('common/lib/ldclient').ldclient
moment = require('moment')
NoticeBanner = require('common/components/notice-banner/notice-banner').default
React = require 'react'
t = require('views/internal/recup-with-helpers')('board_limits')
trackUe = require 'debug/trackUe'
_ = require 'underscore'

isDesktop = ClientConfig.get('appId') == 'desktop'

module.exports = class DowngradePeriodBanner extends React.Component
  displayName: 'DowngradePeriodBanner'

  constructor: (props) ->
    super props
    @state =
      isBoardLimitFeatureOn: ldclient.variation('bc.board_limits', false)
      showBanner: true

    @onLDFlagUpdate = @onLDFlagUpdate.bind(@)

    if @props.model?.typeName == 'Board'
      @org = @props.model.getOrganization()
    else if @props.model?.typeName == 'Organization'
      @org = @props.model
    else
      @org = null

    @paidAccount = @org?.get('paidAccount')
    if !@paidAccount || !Accounts.willExpire(@paidAccount) || !@org.isBusinessClass()
      @state.showBanner = false
      return

    @expirationDate = moment(new Date(@paidAccount.expiresAt))
    @gracePeriod = moment(@expirationDate).subtract(30, 'days')
    @failedPaymentDate = moment(@paidAccount.dateStandingChanged)

  shouldRenderDowngradeBanner: ->
    @expirationDate? && @gracePeriod? && moment().isBefore(@expirationDate) && moment().isSameOrAfter(@gracePeriod)

  # Failed payments go to standing 4 (overdue), then ~30 days later it goes
  # to 5 (disabled -- they lose BC features). Then ~60 days later they will
  # get their product removed then standing goes back to 3 (good)
  shouldRenderForcedDowngradeBanner: ->
    @paidAccount && Accounts.isProblem(@paidAccount.standing)

  onLDFlagUpdate: (newVal) ->
    @setState
      isBoardLimitFeatureOn: newVal

  componentDidMount: ->
    ldclient.on 'change:bc.board_limits', @onLDFlagUpdate

  componentWillUnmount: ->
    ldclient.off 'change:bc.board_limits', @onLDFlagUpdate

  dismissBanner: (bannerId) =>
    dirObj = 'board limits downgrade period banner'
    indObj = 'on #{@props.model?.typeName}'
    method = 'by clicking dismiss in banner'
    Auth.me().dismiss(bannerId)
    @setState
      bannerDismissed: true

    trackUe(@props.context, 'dismisses', dirObj, '', indObj, method, { teamId: @org?.id })

  navigateToBillingPage: =>
    trackUe(@props.context, 'navigates', 'board limits restore bc', '', "on #{@props.model?.typeName}", 'by clicking on button in banner', { teamId: @org?.id })
    Controller.navigate @org.getBillingUrl(), { trigger: true }

  render: t.renderable ->
    t.div =>
      if @state.bannerDismissed ||
        !@state.showBanner ||
        isDesktop ||
        !@state.isBoardLimitFeatureOn ||
        !@org?.isPremium() ||
        (!@shouldRenderDowngradeBanner() && !@shouldRenderForcedDowngradeBanner())
          @props.setShown(false)
          return

      @props.setShown(true)
      if !Auth.me().isDismissed('BoardLimitsDowngradePeriod') &&
        @shouldRenderDowngradeBanner()
          t.div '.board-limits-downgrade-period-banner', =>
            t.tag NoticeBanner, {
              onDismiss: @dismissBanner.bind(@, 'BoardLimitsDowngradePeriod')
              actionButton:
                text: t.l 'restore-business-class'
                onClick: @navigateToBillingPage
            }, =>
              t.format 'downgrade-period',
                downgradeDate: @expirationDate.format('LL'),
                orgName: @org.get('displayName')

      if !Auth.me().isDismissed('BoardLimitsForcedDowngradePeriod') &&
        @shouldRenderForcedDowngradeBanner()
          t.div '.board-limits-downgrade-period-banner', =>
            t.tag NoticeBanner, {
              onDismiss: @dismissBanner.bind(@, 'BoardLimitsForcedDowngradePeriod')
              actionButton:
                text: t.l 'restore-business-class'
                onClick: @navigateToBillingPage
            }, =>
              t.format 'forced-downgrade-period',
                failedPaymentDate: @failedPaymentDate.format('LL')
                downgradeDate: @expirationDate.format('LL')
                orgName: @org.get('displayName')



// WEBPACK FOOTER //
// ./app/scripts/views/board-limits/downgrade-period-banner.coffee